import React from 'react'

import {
  Card,
  LightSelect,
  Checkbox,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func, bool } from 'prop-types'

import { donationRates } from '../../../Static/constants'

function Form({
  donationRate,
  setDonationRate,
  isParticipating,
  setIsParticipating,
}) {
  return (
    <div className="cgt-mb-20 donation-form">
      <p className="cgt-legacy-text-lead">Donation settings</p>
      <p className="cgt-legacy-text-default cgt-mt-10">
        By participating in donation process you are able to contribute part of
        your revenue to support refugees in Ukraine fleeing away from the war.
        All the contributed funds will be paid to UNHCR, the UN Refugee Agency
      </p>

      <p>
        You can manage your preferences by selecting the percentage of reduction
        in your earnings that will be contributed for charity purposes. You are
        able to activate or deactivate this option whenever you want. CGTrader
        reserves the right to terminate this feature at its discretion.
      </p>

      <p>
        Consent: By reducing my earning rate I agree that CGTrader dedicates
        earnings received due to the reduction to the charity and pays out
        directly the amounts to the charity organizations on its own name and
        account
      </p>

      <div className="sales-form__settings-container">
        <div className="cgt-mb-20">
          <Checkbox
            checkedColor="primary"
            id="checkbox-story"
            label="I want to participate in all available programs"
            isChecked={isParticipating}
            onChange={() => setIsParticipating(!isParticipating)}
          />
        </div>

        <Card customClass="donation-rate-card" hasBorder isRounded style={{ overflow: 'visible', zIndex: 450 }}>
          <p className="cgt-legacy-text-default">
            Adjust the percentage you want to share for donations.
          </p>
          <div
            className="cgt-mb-20"
            style={{
              width: '330px',
              zIndex: 2,
              position: 'relative',
            }}
          >
            <span className="light-select__label cgt-mb-10">Donation rate</span>
            <LightSelect
              id="test-light-select"
              menuClassName="menu-classname"
              name="test-light-select"
              onChange={setDonationRate}
              options={
                isParticipating
                  ? [{ value: '', label: 'Select percentage', disabled: true }, ...donationRates]
                  : [{ value: '', label: 'Select percentage', disabled: true }]
              }
              value={donationRate}
            />
          </div>
        </Card>
      </div>
    </div>
  )
}

Form.propTypes = {
  donationRate: string.isRequired,
  setDonationRate: func.isRequired,
  isParticipating: bool.isRequired,
  setIsParticipating: func.isRequired,
}

export default Form
